import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import ModalDialog from '../modal-dialog/ModalDialog'

const TITLE = 'הסרת כתובת שיווקית'
const EXPLANATION = 'הסרת הכתובת תבטל גם את הסכמת הנמען לקבלת דיוור שיווקי בכתובת הזאת.'
const CONFIRM_LABEL = 'הסרה וביטול הסכמה'
const DECLINE_LABEL = 'ביטול'

export default function MarketingRemovalDialog({
    open = false,
    detail = null,
    onConfirm,
    onDecline,
}) {
    const commands = [
        {
            label: DECLINE_LABEL,
            color: 'secondary',
            testId: 'marketing-removal-decline',
            onClick: () => onDecline?.(),
        },
        {
            label: CONFIRM_LABEL,
            testId: 'marketing-removal-confirm',
            position: 'end',
            onClick: () => onConfirm?.(),
        },
    ]

    return (
        <ModalDialog
            open={open}
            title={TITLE}
            commands={commands}
            onClose={onDecline}
        >
            <MDBox
                display="flex"
                flexDirection="column"
                gap="0.75rem"
                data-testid="marketing-removal-dialog"
            >
                <MDTypography variant="body2">{EXPLANATION}</MDTypography>

                {detail?.value != null && (
                    <MDTypography variant="body2" fontWeight="medium">
                        {detail.value}
                    </MDTypography>
                )}
            </MDBox>
        </ModalDialog>
    )
}
